var render = function render(){var _vm=this,_c=_vm._self._c;return _c('depo-deals')
}
var staticRenderFns = []

export { render, staticRenderFns }